import { Offcanvas, Form, Row, Col, Button } from 'react-bootstrap';
import Select from 'react-select';
import Flatpickr from 'react-flatpickr';

/**
 * FilterProjectFilesOffcanvas - Custom Filter for Project Files
 * 
 * Filter fields:
 * - Search by Keywords (text input)
 * - Categories (multi-select)
 * - Uploaded By (multi-select team members)
 * - Start Date (date picker)
 * - End Date (date picker)
 */
const FilterProjectFilesOffcanvas = ({ 
    show, 
    onHide,
    filterKeywords,
    setFilterKeywords,
    filterCategories,
    setFilterCategories,
    filterUploadedBy,
    setFilterUploadedBy,
    filterStartDate,
    setFilterStartDate,
    filterEndDate,
    setFilterEndDate,
    categoryOptions,
    teamMembers,
    onApply,
    onClear
}) => {
    const handleReset = () => {
        setFilterKeywords('');
        setFilterCategories([]);
        setFilterUploadedBy([]);
        setFilterStartDate(null);
        setFilterEndDate(null);
        if (onClear) onClear();
    };

    const handleApply = () => {
        if (onApply) onApply();
        onHide();
    };

    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header className='px-4 py-3' closeButton>
                <Offcanvas.Title className='display-1'>Filter Files</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className='px-4 py-3'>
                <Form>
                    <Row className='gy-2'>
                        {/* Search by Keywords */}
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Search by Keywords</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Search by keywords..."
                                    value={filterKeywords}
                                    onChange={(e) => setFilterKeywords(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        {/* Categories */}
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Categories</Form.Label>
                                <Select
                                    isMulti
                                    options={categoryOptions}
                                    value={filterCategories}
                                    onChange={setFilterCategories}
                                    placeholder="Select categories..."
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    isClearable
                                />
                            </Form.Group>
                        </Col>

                        {/* Uploaded By */}
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Uploaded By</Form.Label>
                                <Select
                                    isMulti
                                    options={teamMembers}
                                    value={filterUploadedBy}
                                    onChange={setFilterUploadedBy}
                                    placeholder="Select team members..."
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    isClearable
                                />
                            </Form.Group>
                        </Col>

                        {/* Start Date */}
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Start Date</Form.Label>
                                <Flatpickr
                                    value={filterStartDate}
                                    onChange={([date]) => setFilterStartDate(date)}
                                    className="form-control"
                                    options={{
                                        dateFormat: 'd M Y',
                                        allowInput: true,
                                        disableMobile: true,
                                        enableTime: false,
                                    }}
                                    placeholder="Select start date"
                                />
                            </Form.Group>
                        </Col>

                        {/* End Date */}
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>End Date</Form.Label>
                                <Flatpickr
                                    value={filterEndDate}
                                    onChange={([date]) => setFilterEndDate(date)}
                                    className="form-control"
                                    options={{
                                        dateFormat: 'd M Y',
                                        minDate: filterStartDate,
                                        allowInput: true,
                                        disableMobile: true,
                                        enableTime: false,
                                    }}
                                    placeholder="Select end date"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Offcanvas.Body>
            <div className="p-3 border-top">
                <div className="d-flex justify-content-between">
                    <Button variant="link" className='text-decoration-none' onClick={handleReset}>
                        Reset
                    </Button>
                    <Button variant="primary" onClick={handleApply}>
                        Apply Filters
                    </Button>
                </div>
            </div>
        </Offcanvas>
    );
};

export default FilterProjectFilesOffcanvas;
